export default __webpack_public_path__ + "static/media/ritualisticbloodshed.e449538f.png";